import { render, staticRenderFns } from "./settingSazito.vue?vue&type=template&id=6e526c7e&scoped=true&"
import script from "./settingSazito.vue?vue&type=script&lang=js&"
export * from "./settingSazito.vue?vue&type=script&lang=js&"
import style0 from "./settingSazito.vue?vue&type=style&index=0&id=6e526c7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e526c7e",
  null
  
)

export default component.exports